<template>
    <div class="about">
        <v-header/>
        <v-sidebar/>
        <div class="content-box">
            <div class="content">
                <div>
                    <div class="crumbs">
                        <el-breadcrumb separator="/">
                            <el-breadcrumb-item>
                                <i class="el-icon-paperclip"></i> 用户管理
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <div class="container">
                        <div class="handle-box">
                            <el-input v-model="query.id"  placeholder="用户id" class="handle-input mr10"></el-input>
                            <el-input v-model="query.unameLike" placeholder="用户名" class="handle-input mr10"></el-input>
                            <el-input v-model="query.rnameLike" placeholder="姓名" class="handle-input mr10"></el-input>
                            <el-input v-model="query.mobileLike" placeholder="手机号" class="handle-input mr10"></el-input>
                            <el-input v-model="query.emailLike" placeholder="邮箱" class="handle-input mr10"></el-input>

                            <el-date-picker
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    v-model="query.regTs"
                                    type="date"
                                    placeholder="注册日期">
                            </el-date-picker>
                            <el-select v-model="query.state" placeholder="状态">
                                <el-option label="" value=""></el-option>
                                <el-option label="正常" value="1"></el-option>
                                <el-option label="禁言" value="0"></el-option>
                            </el-select>
                            <el-select v-model="query.role" placeholder="角色">
                                <el-option label="" value=""></el-option>
                                <el-option label="使用成员" value="2"></el-option>
                                <el-option label="收集成员" value="1"></el-option>
                                <el-option label="调研组员" value="50"></el-option>
                                <el-option label="管理员" value="100"></el-option>
                                <el-option label="禁止访问" value="-1"></el-option>
                                <el-option label="待审核" value="0"></el-option>
                            </el-select>
                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                            <el-button type="danger" icon="el-icon-delete" @click="handleSearchClear">清空搜索条件</el-button>
                            <el-button v-if="lander.role=='100'" type="success" icon="el-icon-plus" @click="handleAdd">添加用户</el-button>

                        </div>
                        <el-table :data="tableData" border class="table" ref="multipleTable"
                                  header-cell-class-name="table-header" size="mini">
                            <el-table-column prop="id" label="ID" width="100" align="center"
                                             fixed="left"></el-table-column>

                            <el-table-column  label="用户名/角色" align="center" width="200"
                                             fixed="left">
                                <template #default="scope">
                                    <span  @click="handleInfo(scope.$index, scope.row)">{{scope.row.uname}}</span>
                                    <span v-if="scope.row.role=='100'">
                                        <el-tag type="danger" size="mini">管理员</el-tag>
                                    </span>
                                    <span v-if="scope.row.role=='50'"
                                       @click="handleCancelTypeManager(scope.$index, scope.row)">
                                        <el-tag type="primary" size="mini">调研组员</el-tag>
                                    </span>
                                    <span v-if="scope.row.role=='1'">
                                        <el-tag type="success" size="mini">收集成员</el-tag>
                                    </span>
                                    <span v-if="scope.row.role=='2'">
                                        <el-tag type="warning" size="mini">使用成员</el-tag>
                                    </span>
                                    <span v-if="scope.row.role=='0'">
                                        <el-tag type="info" size="mini">待验证</el-tag>
                                    </span>
                                    <span v-if="scope.row.role=='-1'">
                                        <el-tooltip class="item" effect="dark" :content="'禁止原因：'+scope.row.shMsg"
                                                    placement="top-start">
                                            <el-tag  class="custom-tag" size="mini">禁止访问</el-tag>
                                        </el-tooltip>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column label="头像" width="60" align="center">
                                <template #default="scope">
                                    <img @click="handleInfo(scope.$index, scope.row)" :src="scope.row.faceimg"
                                         style="width: 30px;height: 30px;">
                                </template>
                            </el-table-column>
                            <el-table-column prop="rname" label="真实姓名" align="center" width="120"></el-table-column>

                            <el-table-column label="邮箱" width="300" align="center">
                                <template #default="scope">
                                    {{scope.row.email}}
                                    <el-tag v-if="scope.row.emailVaild!=null&&scope.row.emailVaild=='1'" type="danger">
                                        已验证
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="手机号" width="300" align="center">
                                <template #default="scope">
                                    <el-tag> {{scope.row.countryMobile}} {{scope.row.quhaoMobile}}</el-tag>
                                    {{scope.row.mobile}}
                                </template>
                            </el-table-column>

                            <el-table-column label="状态" width="100" align="center">
                                <template #default="scope">
                                    <p v-if="scope.row.state=='1'">
                                        <el-tag type="success">正常</el-tag>
                                    </p>
                                    <p v-else>
                                        <el-tooltip class="item" effect="dark"
                                                    :content="'期限：'+scope.row.gagStart+' 到 '+scope.row.gagEnd"
                                                    placement="top-start">
                                            <el-tag type="danger">禁言</el-tag>
                                        </el-tooltip>
                                    </p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="tempUpass" label="临时密码" width="100" align="center"></el-table-column>
                            <el-table-column prop="loginTs" label="最近一次登录" width="200" align="center"></el-table-column>
                            <el-table-column prop="regTs" label="注册时间" width="200" align="center"></el-table-column>

                            <el-table-column label="操作" width="90" align="center" fixed="right">
                                <template #default="scope">
                                    <el-dropdown v-if="lander.role=='100'">
                                        <el-button type="primary">
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-info"
                                                           @click="handleInfo(scope.$index, scope.row)">详情
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-key"
                                                           @click="handleSetUpass(scope.$index, scope.row)">设置密码
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-close-notification"
                                                           @click="handleJinYan(scope.$index, scope.row)">禁言
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.state=='0'">
                                                <el-button type="text" icon="el-icon-microphone"
                                                           @click="handleCancelJinYan(scope.$index, scope.row)">取消禁言
                                                </el-button>
                                            </el-dropdown-item>

                                            <el-dropdown-item v-if="scope.row.role!='100'&&scope.row.role!='50'">
                                                <el-button type="text" icon="el-icon-s-release"
                                                           @click="handleNotPass(scope.$index, scope.row)">禁止访问
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.role!='50'&&scope.row.role!='1'">
                                                <el-button type="text" icon="el-icon-user-solid"
                                                           @click="handlePass(scope.$index, scope.row)">收集成员
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button v-if="scope.row.role=='50'" type="text" icon="el-icon-user"
                                                           @click="handleCancelTypeManager(scope.$index, scope.row)">
                                                    取消调研组员
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button v-if="scope.row.role=='1'" type="text" icon="el-icon-user"
                                                           @click="handleSetAdmin(scope.$index, scope.row)">设置管理员
                                                </el-button>
                                            </el-dropdown-item>

                                             <el-dropdown-item>
                                                <el-button v-if="scope.row.role=='1'" type="text" icon="el-icon-user"
                                                           @click="handleSetDiaoyan(scope.$index, scope.row)">设置调研组员
                                                </el-button>
                                            </el-dropdown-item>
                                             <el-dropdown-item>
                                                <el-button v-if="scope.row.role!='50'&&scope.row.role!='100' &&scope.row.role!='2'" type="text" icon="el-icon-user"
                                                           @click="handleSetXianxia(scope.$index, scope.row)">设置使用成员
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-edit"
                                                           @click="handleEdit(scope.$index, scope.row)">编辑
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.role!='100'&&scope.row.role!='50'">
                                                <el-button type="text" icon="el-icon-delete" class="red"
                                                           @click="handleDelete(scope.$index, scope.row)">删除
                                                </el-button>
                                            </el-dropdown-item>

                                        </el-dropdown-menu>
                                    </el-dropdown>

                                    <el-dropdown v-if="lander.role=='50'">
                                        <el-button type="primary">
                                            操作<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <el-button type="text" icon="el-icon-close-notification"
                                                           @click="handleJinYan(scope.$index, scope.row)">禁言
                                                </el-button>
                                            </el-dropdown-item>
                                            <el-dropdown-item v-if="scope.row.state=='0'">
                                                <el-button type="text" icon="el-icon-microphone"
                                                           @click="handleCancelJinYan(scope.$index, scope.row)">取消禁言
                                                </el-button>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="pagination">
                            <el-pagination
                                    background
                                    @size-change="handleSizeChange"
                                    @current-change="handlePageChange"
                                    :current-page="query.pageNo"
                                    :page-sizes="[10,20,30]"
                                    :page-size="query.pageSize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="pageTotal">
                            </el-pagination>
                        </div>
                    </div>


                </div>
            </div>
        </div>


        <!-- 添加或者编辑弹出框 -->
        <el-dialog :title="'添加&编辑-'+ (dataForm.uname!=undefined?dataForm.uname:'')" :visible.sync="addVisible">
            <el-form
                    label-width="120px"
                    :model="dataForm"
                    :rules="dataFormRule"
                    ref="dataForm"
            >
                <el-form-item label="用户名" prop="uname">
                    <el-input v-model="dataForm.uname"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="rname">
                    <el-input v-model="dataForm.rname"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-select v-model="dataForm.qcountryMobile" style="width: 100px;">
                        <el-option @click.native="selqcm(t)" v-for="(t,i) in qcountryMobileLi"
                                   :label="t.name+t.value" :value="t.name+t.value" :key="i"></el-option>
                    </el-select>
                    <el-input placeholder="请输入手机" v-model="dataForm.mobile" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="dataForm.email"></el-input>
                </el-form-item>
                <el-form-item label="临时密码" v-if="dataForm.id==undefined||dataForm.id==''">
                    <el-input v-model="tempUpass"></el-input>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="addVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveAdd">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 详情 -->
        <el-dialog :title="infodata.uname+'  用户信息'" :visible.sync="infoVisible">
            <table class="mytable">
                <tr>
                    <td>头像</td>
                    <td><img :src="infodata.faceimg" style="width:100px;"></td>
                    <td>最近照片</td>
                    <td><img :src="infodata.pimg" style="max-width: 100%;"></td>
                </tr>
                <tr>
                    <td>用户id</td>
                    <td>{{infodata.id}}</td>
                    <td>用户名</td>
                    <td>{{infodata.uname}}</td>
                </tr>
                <tr>
                    <td>姓名</td>
                    <td>{{infodata.rname}}</td>
                    <td>手机号</td>
                    <td>({{infodata.countryMobile}}{{infodata.quhaoMobile}}){{infodata.mobile}}</td>
                </tr>
                <tr>
                    <td>邮箱</td>
                    <td>{{infodata.email}}</td>
                    <td>邮箱验证</td>
                    <td>
                        <el-tag v-if="infodata.emailVaild=='1'">已验证</el-tag>
                        <el-tag v-if="infodata.emailVaild!='1'" type="info">未验证</el-tag>
                    </td>
                </tr>
                <tr>
                    <td>常住地址</td>
                    <td>{{infodata.address}}</td>
                    <td>角色</td>
                    <td>
                        <p v-if="infodata.role=='100'">
                            <el-tag type="success">管理员</el-tag>
                        </p>
                        <p v-if="infodata.role=='50'">
                            <el-tag type="primary">调研组员</el-tag>
                        </p>
                        <p v-if="infodata.role=='1'">
                            <el-tag type="warning">收集成员</el-tag>
                        </p>
                        <p v-if="infodata.role=='2'">
                            <el-tag type="warning">使用成员</el-tag>
                        </p>
                        <p v-if="infodata.role=='0'">
                            <el-tag type="info">待验证</el-tag>
                        </p>
                        <p v-if="infodata.role=='-1'">
                            <el-tag type="danger">禁止访问</el-tag>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>管理板块</td>
                    <td><el-tag v-for="(t,i) in infodataUtli" :key="i">{{t.name}}</el-tag></td>
                    <td>禁止访问原因</td>
                    <td><b v-if="infodata.role=='-1'">{{infodata.shMsg}}</b></td>

                </tr>
                <tr>
                    <td>审核时间</td>
                    <td>{{infodata.shTs}}</td>
                    <td>状态</td>
                    <td>
                        <p v-if="infodata.state=='1'">
                            <el-tag type="success">正常</el-tag>
                        </p>
                        <p v-else>
                            <el-tag type="danger">禁言</el-tag>
                        </p>
                    </td>

                </tr>
                <tr>
                    <td>禁言期限</td>
                    <td><b v-if="infodata.state=='0'">{{infodata.gagStart}}到{{infodata.gagEnd}}</b></td>
                    <td>注册时间</td>
                    <td>{{infodata.regTs}}</td>

                </tr>
                <tr>
                    <td>最近登录时间</td>
                    <td>{{infodata.loginTs}}</td>
                    <td>临时密码</td>
                    <td>{{infodata.tempUpass}}</td>

                </tr>
                <tr>
                    <td>添加者id</td>
                    <td>{{infodata.createUid}}</td>
                    <td>添加者用户名</td>
                    <td>{{infodata.createUname}}</td>
                </tr>
            </table>



        </el-dialog>


        <!-- 禁言 -->
        <el-dialog :title="'禁言-'+  jydata.uname " :visible.sync="jinyanVisible">
            <el-form label-width="120px">
                <el-form-item label="禁言截止时间">
                    <el-input v-model="jydata.gagEnd" type="date"></el-input>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="jinyanVisible = false">取 消</el-button>
                    <el-button type="primary" @click="jinyanHandle">确 定</el-button>
                </span>
            </template>
        </el-dialog>

        <!-- 密码 -->
        <el-dialog :title="'设置临时密码-'+  upassdata.uname " :visible.sync="upassVisible">
            <el-form label-width="120px">
                <el-form-item label="临时密码">
                    <el-input v-model="upassdata.tempUpass"></el-input>
                    <p>临时密码将替换他以前的密码，请慎重设置</p>
                </el-form-item>

            </el-form>

            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="upassVisible = false">取 消</el-button>
                    <el-button type="primary" @click="setupassHandle">确 定</el-button>
                </span>
            </template>
        </el-dialog>


        <!-- 调研组员管理 -->
        <el-dialog :title="  managerTypedata.uname + '--调研组员权限管理' " :visible.sync="managerTypeVisible">
            <p>
            
                <el-popconfirm placement="top" title="确定撤销其调研组员权限吗？" @confirm="handleDelAllManager()" size="small">
                    <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">撤销调研组员</el-button>

                </el-popconfirm>

            </p>
            <el-table :data="managerTypeLi" border class="table" header-cell-class-name="table-header">
                <template #default="scope">
                        <el-popconfirm placement="top" title="确定撤销他的调研组员的权限么？"
                                       @confirm="handleDelManager(scope.$index, scope.row)" size="small">
                            <el-button type="danger" icon="el-icon-delete" size="mini" slot="reference">撤销调研组员</el-button>
                        </el-popconfirm>
                    </template>
            </el-table>
        </el-dialog>


    </div>
</template>

<script>
    import vHeader from "./Header.vue";
    import vSidebar from "./Sidebar.vue";
    import {
        admin_users_page,
        admin_users_checkOne,
        admin_users_save,
        admin_users_del,
        admin_users_shnotpass,
        admin_users_shpass,
        admin_users_setadmin,
        admin_users_jinyan,
        admin_users_canceljinyan,
        admin_users_setTempUpass,
        admin_users_type_seeTypes, admin_type_users_del, admin_type_users_del_by_manageUid,
        admin_type_users_setDiaoyanByManageUid,
        admin_users_setxianxia 
    } from '../../api';
    import {dealResult, qcountryMobileLi, pwdReg} from "../../api/common";
    import {validateEmail, validateMobile, validateRealname, validateUname} from "../../api/validator";

    export default {
        name: "AdminUsers",
        components: {
            vHeader,
            vSidebar,
        },
        data() {
            const checkExistUname = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    admin_users_checkOne({
                        name: 'uname',
                        value: str,
                        id: this.dataForm.id == undefined ? '' : this.dataForm.id,
                        uid: this.lander.uid,
                        token: this.lander.token
                    }).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            const checkExistEmail = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    admin_users_checkOne({
                        name: 'email',
                        value: str,
                        id: this.dataForm.id == undefined ? '' : this.dataForm.id,
                        uid: this.lander.uid,
                        token: this.lander.token
                    }).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            const checkExistMobile = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    admin_users_checkOne({
                        name: 'mobile',
                        value: str,
                        id: this.dataForm.id == undefined ? '' : this.dataForm.id,
                        uid: this.lander.uid,
                        token: this.lander.token
                    }).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            return {
                qcountryMobileLi: [],
                tableData: [],
                query: {
                    regTs:'',
                    id: '',
                    unameLike: '',
                    mobileLike: '',
                    rnameLike: '',
                    emailLike: '',
                    role: '',
                    state: '',
                    pageNo: 1,
                    pageSize: 10,
                },
                pageTotal: 0,
                addVisible: false,
                lander: {},

                tempUpass: '',
                dataForm: {
                    uname: '',
                    rname: "",
                    mobile: "",
                    email: "",
                    qcountryMobile: "",
                    countryMobile: "",
                    quhaoMobile: "",


                },
                dataFormRule: {
                    uname: [
                        {required: true, message: '不能为空', trigger: 'blur'},
                        {validator: validateUname, trigger: "blur"},
                        {validator: checkExistUname, trigger: "blur"}
                    ],
                    rname: [{required: true, message: "请输入姓名", trigger: "blur"},
                        {validator: validateRealname, trigger: "blur"}],
                    mobile: [{required: true, message: "请输入手机号", trigger: "blur"},
                        {validator: validateMobile, trigger: "blur"},
                        {validator: checkExistMobile, trigger: "blur"},],
                    qcountryMobile: [{required: true, message: "请选择区号", trigger: "blur"}],
                    email: [{required: true, message: "请输入邮箱", trigger: "blur"},
                        {validator: validateEmail, trigger: "blur"},
                        {validator: checkExistEmail, trigger: "blur"},],


                },

                infoVisible: false,
                infodata: {},
                infodataUtli:[],

                jinyanVisible: false,
                jydata: '',

                upassVisible: false,
                upassdata: '',

                managerTypeVisible: false,
                managerTypedata: {},
                managerTypeLi: [],

            };
        },
        methods: {
            //删除调研组员
            handleDelAllManager() {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    manageUid: this.managerTypedata.id
                };
                admin_type_users_del_by_manageUid(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("已删除")
                        this.getPage();

                        this.managerTypeVisible = false;

                    } else this.$message.error(res.data.msg)

                })
            },
            //删除调研组员
            handleDelManager(index, row) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                };
                admin_type_users_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("已删除")
                        this.getPage();
                        this.getManageTyeLi(row.manageUid);

                    } else this.$message.error(res.data.msg)

                })
            },
            handleSetUpass(index, row) {
                this.upassVisible = true;
                this.upassdata = row;
            },
            setupassHandle() {
                if (this.upassdata.tempUpass == '') {
                    this.$message.info('请输入密码');
                    return;
                }
                if (!pwdReg.test(this.upassdata.tempUpass)) {
                    this.$message.info('密码格式6-20位数字或下划线或字母');
                    return;
                }
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: this.upassdata.id,
                    tempUpass: this.upassdata.tempUpass
                };
                admin_users_setTempUpass(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("操作成功");
                        this.upassVisible = false;
                        this.getPage();
                    } else {
                        this.$message.info(res.data.msg);
                    }
                })
            },
            jinyanHandle() {
                if (this.jydata.gagEnd == '' || this.jydata.gagEnd == null) {
                    this.$message.info("请输入截止日期");
                    return;
                }
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: this.jydata.id,
                    gagEnd: this.jydata.gagEnd
                };
                admin_users_jinyan(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.$message.success("操作成功");
                        this.jinyanVisible = false;
                        this.getPage();
                    } else {
                        this.$message.info(res.data.msg);
                    }
                })
            },
            handleCancelJinYan(index, row) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                };
                // 二次确认删除
                this.$confirm("确定要对' " + row.uname + " '取消禁言吗？", "提示", {
                    type: "warning",
                }).then(() => {
                    admin_users_canceljinyan(o).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success("操作成功");
                            this.getPage();
                        } else {
                            this.$message.info(res.data.msg);
                        }
                    })
                });

            },
            handleJinYan(index, row) {
                this.jinyanVisible = true;
                this.jydata = row;
            },
            //审核通过
            handlePass(index, row) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id
                };
                this.$confirm("确定要将' " + row.uname + " '设置为收集成员么？", "提示", {
                    type: "warning",
                }).then(() => {
                    admin_users_shpass(o).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success("操作成功");
                            this.tableData.splice(index, 1);
                            this.getPage();
                        } else {
                            this.$message.info(res.data.msg);
                        }
                    })
                });

            },
            //禁止访问
            handleNotPass(index, row) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                    shMsg: row.shMsg
                };
                this.$prompt('请输入禁止访问的原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({value}) => {
                    let o = {
                        uid: this.lander.uid,
                        token: this.lander.token,
                        id: row.id,
                        shMsg: value
                    };
                    admin_users_shnotpass(o).then((res) => {
                        dealResult(res.data);
                        if (res.data.status == 1) {
                            this.$message.success("操作成功");
                            this.tableData.splice(index, 1);
                            this.getPage();

                        } else {
                            this.$message.info(res.data.msg);
                        }
                    })
                })

            },
            //删除操作
            handleDelete(index, row) {

                // 二次确认删除
                this.$confirm("确定要删除' " + row.uname + " '吗？", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        admin_users_del({id: row.id, uid: this.lander.uid, token: this.lander.token}).then((res) => {
                            if (res.data.status == 1) {
                                dealResult(res.data);
                                this.$message.success("已删除成功");
                                //this.tableData.splice(index, 1);
                                this.getPage();
                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: res.data.msg,
                                    duration: 2000
                                });
                            }

                        })

                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });


            },
            //取消调研组员
            handleCancelTypeManager(index, row) {
                this.managerTypeVisible = true;
                this.managerTypedata = row;
                this.getManageTyeLi(row.id);

            },
            getManageTyeLi(id) {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    manageUid: id
                }
                admin_users_type_seeTypes(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.managerTypeLi = res.data.obj;
                        if(this.infoVisible)this.infodataUtli=res.data.obj;

                    }

                })
            },
            //确定设置为管理员
            handleSetAdmin(index, row) {
                // 二次确认删除
                this.$confirm("确定要设置' " + row.uname + " '成为管理员么？", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        admin_users_setadmin({
                            id: row.id,
                            uid: this.lander.uid,
                            token: this.lander.token
                        }).then((res) => {
                            if (res.data.status == 1) {
                                dealResult(res.data);
                                this.$message.success("操作成功");
                                this.getPage();
                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: res.data.msg,
                                    duration: 2000
                                });
                            }

                        })

                    })

            },

            //确定设置为使用成员
            handleSetXianxia(index, row) {
                // 二次确认删除
                this.$confirm("确定要设置' " + row.uname + " '成为使用成员么？", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        admin_users_setxianxia({
                            id: row.id,
                            uid: this.lander.uid,
                            token: this.lander.token
                        }).then((res) => {
                            if (res.data.status == 1) {
                                dealResult(res.data);
                                this.$message.success("操作成功");
                                this.getPage();
                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: res.data.msg,
                                    duration: 2000
                                });
                            }

                        })

                    })

            },

            //确定设置为调研组员
            handleSetDiaoyan(index, row) {
                // 二次确认
                this.$confirm("确定要设置' " + row.uname + " '成为调研组员么？", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        console.log(row.id);
                        admin_type_users_setDiaoyanByManageUid({
                            id: row.id,
                            uid: this.lander.uid,
                            token: this.lander.token
                        }).then((res) => {
                            if (res.data.status == 1) {
                                dealResult(res.data);
                                this.$message.success("操作成功");
                                this.getPage();
                            } else {
                                this.$notify({
                                    title: '提示',
                                    message: res.data.msg,
                                    duration: 2000
                                });
                            }

                        })

                    })

            },
            handleInfo(index, row) {
                this.infodata = row;
                this.infoVisible = true;
                this.getManageTyeLi(row.id);
            },
            handleEdit(index, row) {
                this.addVisible = true;
                this.dataForm.id = row.id;
                this.dataForm.uname = row.uname;
                this.dataForm.rname = row.rname;
                this.dataForm.mobile = row.mobile;
                this.dataForm.email = row.email;
                this.dataForm.countryMobile = row.countryMobile;
                this.dataForm.quhaoMobile = row.quhaoMobile;
                this.dataForm.qcountryMobile = row.countryMobile + row.quhaoMobile;
            },
            selqcm(t) {
                console.log(t)
                this.dataForm.countryMobile = t.name;
                this.dataForm.quhaoMobile = t.value;
            },

            //弹出添加操作弹框
            handleAdd() {
                this.dataForm = {}
                this.addVisible = true;
            },
            handleSearchClear() {
                this.query.regTs = '';
                this.query.id = '';
                this.query.unameLike = '';
                this.query.rnameLike = '';
                this.query.mobileLike = '';
                this.query.emailLike = '';
                this.query.state = '';
                this.query.role = '';
                this.query.pageNo = 1;
                this.getPage();
            },
            // 查询操作
            handleSearch() {
                this.query.pageNo = 1;
                this.getPage();
            },

            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.getPage();
            },
            handleSizeChange(val) {
                this.query.pageNo = 1;
                this.query.pageSize = val;
                this.getPage();
            },
            saveAdd() {


                this.$refs.dataForm.validate(valid => {
                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message.error("请按提示填写表单");
                        return false;
                    } else {


                        if (this.dataForm.id == undefined || this.dataForm.id == '') {
                            if (this.tempUpass == '') {
                                this.$message.info('请输入密码');
                                return;
                            }
                            if (!pwdReg.test(this.tempUpass)) {
                                this.$message.info('密码格式6-20位数字或下划线或字母');
                                return;
                            }
                            this.dataForm.tempUpass = this.tempUpass;
                        }


                        this.dataForm.uid = this.lander.uid;
                        this.dataForm.token = this.lander.token;
                        this.loading = this.$loading({
                            lock: true,
                            text: "保存中，请稍等...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });
                        admin_users_save(this.dataForm).then((res) => {
                            this.loading.close();
                            dealResult(res.data);
                            if (res.data.status == 1) {
                                this.$message.success("已保存");
                                this.addVisible = false;
                                this.getPage();

                                if (this.dataForm.id == undefined || this.dataForm.id == '') {
                                    this.tempUpass == '';
                                }

                            } else {
                                this.$message.error(res.data.msg)
                            }
                        }).catch(() => {
                            this.loading.close();
                            this.$message.info('请求失败，请检查网络');
                        });
                    }
                })
            },


            //获取列表数据
            getPage() {
                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                admin_users_page(this.query).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.tableData = res.data.obj.list
                        this.pageTotal = res.data.obj.total//该页总共多少条记录
                    }

                })
            },

        },
        mounted() {
            this.lander = JSON.parse(this.$store.state.logininfo);

            this.qcountryMobileLi = qcountryMobileLi;
            this.dataForm.qcountryMobile = qcountryMobileLi[0].name + qcountryMobileLi[0].value;
            this.dataForm.countryMobile = qcountryMobileLi[0].name;
            this.dataForm.quhaoMobile = qcountryMobileLi[0].value;


            this.getPage()

        }
    }
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
        width: 150px;
    }

    .custom-tag {
  background-color: #FFFFFF; /* 金色背景 */
  color: #A9A9A9; /* 深灰色文字 */
  border-radius: 15px; /* 圆角 */
  border: 1px solid #FFA500; /* 橙色边框 */
}

    /*滚动条的宽度*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        width: 6px;
        height: 10px;
    }

    /*滚动条滑块*/
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        background-color: #409eff;
        /*border-radius: 3px;*/
    }

    .mytable {
        width: 100%;
    }

    .mytable td {
        border: 1px solid #f3f3f3;
        line-height: 30px;
    }

    .mytable td:nth-child(1), .mytable td:nth-child(3) {
        background: #f3f3f3;
        text-align: center;
    }

    .mytable td:nth-child(2), .mytable td:nth-child(4) {
        text-align: left;
    }
</style>
